(ns frontend.view.nev.surveys.events
  (:require
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.routing :as routing]))

(defn create-process!
  [{:keys [entity]}]
  (let [data {:entity/type              :entity.type/survey-process
              :common/containing-entity (:db/id entity)}]
    (entity-actions/*->create
     data
     (fn [resp]
       (js/console.log " Success : " resp)
       (let [process (:body resp)
             process-id (:db/id process)]
         (routing/open-entity-type :entity.type/survey-process process-id
                                   :profile-id (:db/id entity))))
     (fn [err]
       (logging/error "Could not create Survey process " err)))))
